import React from 'react';

interface PolicyProps {
  event: any;
}

const Policy: React.FC<PolicyProps> = ({ event }) => {
  if (!event?.content?.policy && !event?.content?.refund_policy) {
    return null;
  }

  return (
    <div className="policy-section">
      <h3>
        <i className="fas fa-shield-alt me-2"></i>
        Event Policies
      </h3>
      <div className="policy-content">
        {event.content.policy && (
          <div 
            className="main-policy"
            dangerouslySetInnerHTML={{ __html: event.content.policy }}
          />
        )}
        
        {event.content.refund_policy && (
          <div className="highlight-box">
            <h4>
              <i className="fas fa-undo me-2"></i>
              Refund Policy
            </h4>
            <p>{event.content.refund_policy}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Policy;
